import CssBaseline from '@mui/material/CssBaseline';
import { RouterProvider } from '@tanstack/react-router';
import { Provider } from 'react-redux';

import { router } from '@/app/router';
import { store } from '@/app/store';
import { ThemeProvider } from '@/app/themes';
import { configureAmplify, injectStore } from '@/features/auth';
import NotistackSnackbarProvider from '@/shared/context/NotistackSnackbarProvider';
import { isIframeWindow } from '@/shared/utils/utils';

// Configure normal amplify auth if not in an iframe app
if (!isIframeWindow()) {
  configureAmplify();
}

injectStore(store);

const App = () => {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <CssBaseline />

        <NotistackSnackbarProvider>
          <RouterProvider router={router} />
        </NotistackSnackbarProvider>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
